module.exports = __webpack_public_path__ + "img/luna-green.267bdd6b.png";